export const PRONOUNS_OPTIONS = [
  { label: "He/Him/His", value: "he/him" },
  { label: "She/Her/Hers", value: "she/her" },
  { label: "They/Them/Theirs", value: "they/them" },
  { label: "Other", value: "other" }
] as const;

const PRONOUNS_ALIASES: Record<
  string,
  (typeof PRONOUNS_OPTIONS)[number]["value"]
> = {
  "he/him": "he/him",
  "he/him/his": "he/him",
  "she/her": "she/her",
  "she/her/hers": "she/her",
  "they/them": "they/them",
  "they/them/theirs": "they/them",
  other: "other"
};

const normalizePronounsAliasKey = (
  value: string | null | undefined
): string => {
  return (value ?? "").trim().toLowerCase();
};

export const getPronounsSelectValue = (
  value: string | null | undefined
): string => {
  const normalizedKey = normalizePronounsAliasKey(value);
  if (!normalizedKey) return "";
  return PRONOUNS_ALIASES[normalizedKey] ?? "other";
};

export const isKnownPronounsValue = (
  value: string | null | undefined
): boolean => {
  const normalizedKey = normalizePronounsAliasKey(value);
  return Boolean(normalizedKey && PRONOUNS_ALIASES[normalizedKey]);
};

export const getLegacyOtherPronounsFallback = (
  pronouns: string | null | undefined,
  otherPronouns: string | null | undefined
): string => {
  const otherPronounsValue = (otherPronouns ?? "").trim();
  if (otherPronounsValue) return otherPronounsValue;

  const pronounsValue = (pronouns ?? "").trim();
  if (!pronounsValue) return "";
  if (isKnownPronounsValue(pronounsValue)) return "";

  return pronounsValue;
};
